import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  isAuthenticated: false,
  emailVerify: null,
  user_profile_image: null
};

const loginSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setloginUserData: (state, action) => {
      state.user = action.payload.user;
      state.isAuthenticated = action.payload.isAuthenticated;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
    setemailVerify: (state, action) => {
      state.emailVerify = action.payload;
    },
    setProfileImageGlobal: (state, action) => {
      state.user_profile_image = action.payload;
    },
  },
});

export const { setloginUserData, logout,setemailVerify,setProfileImageGlobal } = loginSlice.actions;
export default loginSlice.reducer;
